import { render, staticRenderFns } from "./ClientsDashboard.vue?vue&type=template&id=43992c78&"
import script from "./ClientsDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports